var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNewPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9L3.29683 8.1166C3.44374 8.0601 3.5172 8.03185 3.58592 7.99496C3.64696 7.96219 3.70515 7.92437 3.75989 7.8819C3.82151 7.83408 3.87716 7.77843 3.98846 7.66713L8.65712 2.99848C9.1143 2.5413 9.1143 1.80006 8.65713 1.34288C8.19995 0.885706 7.45871 0.885705 7.00153 1.34288L2.33287 6.01154C2.22157 6.12284 2.16592 6.17849 2.1181 6.24011C2.07563 6.29484 2.03781 6.35304 2.00504 6.41408C1.96815 6.4828 1.9399 6.55626 1.8834 6.70317L1 9ZM1 9L1.85185 6.78521C1.91281 6.62672 1.94329 6.54748 1.99557 6.51118C2.04125 6.47946 2.09778 6.46746 2.15241 6.4779C2.21493 6.48983 2.27496 6.54987 2.39504 6.66994L3.33007 7.60498C3.45014 7.72505 3.51018 7.78508 3.52212 7.8476C3.53255 7.90223 3.52055 7.95876 3.48883 8.00445C3.45253 8.05672 3.37329 8.0872 3.2148 8.14816L1 9Z",
    stroke: "#F7665F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNewPen);
export default __webpack_public_path__ + "static/media/edit-new-pen.d35be04fef82bbaf1d7e73b5e2907ffa.svg";
export { ForwardRef as ReactComponent };